import { createRecipe } from './runtime.js';

const toggleButtonConfig = {"name":"toggleButton","defaultVariants":{"outline":false,"type":"text"},"compoundVariants":[{"size":"sm","type":"text","className":"toggleButton--compound__size_sm__type_text"}],"variantMap":{"outline":["false","true"],"size":["lg","md","sm","xl","xs"],"type":["icon_only","text"]}}

export const toggleButton = /* @__PURE__ */ createRecipe(toggleButtonConfig)